<template>
  <div class="container">
    <img src="@/images/pc/v2_header_with_logo.png" class="header" alt="" />

    <img
      src="@/images/pc/v2_leaf_left_big.png"
      class="img-left-leaf-big offset-0"
      alt=""
    />
    <img
      src="@/images/pc/v2_leaf_left_big.png"
      class="img-left-leaf-big offset-1"
      alt=""
    />
    <img
      src="@/images/pc/v2_leaf_left_big.png"
      class="img-left-leaf-big offset-2"
      alt=""
    />
    <img
      src="@/images/pc/v2_leaf_right.png"
      class="img-right-leaf offset-right-0"
      alt=""
    />
    <img
      src="@/images/pc/v2_leaf_right.png"
      class="img-right-leaf offset-right-1"
      alt=""
    />
    <!-- 活动背景 -->
    <div class="activity-background-wrap">
      <div class="activity-background">{{ activityBG }}</div>
      <img
        src="@/images/v2_activity_background.png"
        class="img-activity-background-title"
        alt=""
      />
    </div>

    <!-- 活动主题 -->
    <div class="activity-theme-wrap">
      <div class="activity-theme">
        <p v-for="(item, index) in activityTheme" :key="index">{{ item }}</p>
      </div>
      <img
        src="@/images/v2_activity_theme.png"
        class="img-activity-theme-title"
        alt=""
      />
    </div>
    <!-- 活动内容 -->
    <div class="activity-content-wrap">
      <div class="activity-content">
        <!-- 一、启动发布 -->
        <img
          src="@/images/v2_title1_publish_date.png"
          class="img-activity-content-item-title"
          alt=""
        />
        <div class="content-item">{{ content.publish_date }}</div>
        <!-- 二、征集重点 -->
        <img
          src="@/images/v2_title2_key_point.png"
          class="img-activity-content-item-title"
          alt=""
        />
        <div class="content-item">
          <p v-for="(item, index) in content.key_point" :key="index">
            {{ index + 1 }}.{{ item }}
          </p>
        </div>
        <!-- 三、征集时间 -->
        <img
          src="@/images/v2_title3_date.png"
          class="img-activity-content-item-title"
          alt=""
        />
        <div class="content-item">{{ content.date }}</div>
        <!-- 四、征集形式 -->
        <img
          src="@/images/v2_title4_mode.png"
          class="img-activity-content-item-title"
          alt=""
        />
        <div class="content-item">{{ content.mode[0] }}</div>

        <!-- 方式一 -->
        <div class="content-mode">方式一：</div>
        <div class="content-item">
          <span>{{ content.mode[1] }}</span>
          <div>
            <span class="content-email">{{ content.mode[2] }}</span>
            <span>{{ content.mode[3] }}</span>
          </div>
        </div>
        <div class="btn-download-wrap">
          <a
            href="http://m.aoyou.com/Resource/files/LJFLDJFDLJFDLFJHKKDJLJFS.docx"
            download="活动报名表.docx"
            v-show="!isWeChat"
            ><img
              src="@/images/v2_btn_download.png"
              class="btn_download"
              alt=""
          /></a>
          <div v-show="isWeChat" @click="download">
            <img
              src="@/images/v2_btn_download.png"
              class="btn_download"
              alt=""
            />
          </div>
          <img
            src="@/images/v2_leaf_right.png"
            class="img-right-leaf-above"
            alt=""
          />
        </div>

        <!-- 方式二 -->
        <div class="content-mode">方式二：</div>
        <div class="content-item">在线填写表格</div>

        <ao-you-form
          ref="aoyouForm"
          class="activity-form"
          :itemCount="itemCount"
          target="pc"
        ></ao-you-form>

        <div class="btn-submit-wrap">
          <p>{{ content.agree }}</p>
          <img
            @click="submit"
            src="@/images/v2_submit.png"
            class="btn-submit"
            alt=""
          />
        </div>
        <!-- 评审与踩线 -->
        <img
          src="@/images/v2_title5_judge.png"
          class="img-activity-content-item-title"
          alt=""
        />
        <div class="content-item">{{ content.judge }}</div>
        <!-- 发布及推广 -->
        <img
          src="@/images/v2_title6_publish_public.png"
          class="img-activity-content-item-title"
          alt=""
        />
        <div class="content-item">
          <p v-for="(item, index) in content.publish_public" :key="index">
            {{ item }}
          </p>
        </div>
        <!-- 奖励及荣誉 -->
        <img
          src="@/images/v2_title7_reward_honor.png"
          class="img-activity-content-item-title"
          alt=""
        />
        <div class="content-item">{{ content.honor }}</div>

        <!-- 星星 -->
        <img src="@/images/v2_star.png" class="img-star" alt="" />
      </div>
      <img
        src="@/images/v2_activity_content.png"
        class="img-activity-content-title"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import AoYouForm from "@/components/MicroTravelForm";
import { Toast } from "mint-ui";
import { textUtils } from "@/utils/text";
export default {
  components: {
    AoYouForm,
  },
  computed: {
    isWeChat() {
      return (
        navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
        "micromessenger"
      );
    },
  },
  data() {
    return {
      activityBG: textUtils.activityBG,
      activityTheme: textUtils.activityTheme,
      content: textUtils.content,
      itemCount: 4,
    };
  },
  created(){
    // console.log(" = "+window.location.href)
    // console.log(" = " + (window.location.href.substr(0,7) == 'http://'))
  },
  methods: {
    submit() {
      this.$refs.aoyouForm.submit();
    },
    download() {
      //   if (this.isWeChat()) {
      Toast({
        message: "请点击右上角3个点，选择在浏览器打开",
        position: "middle",
        duration: 3000,
      });
      //   }
    },
    // isWeChat() {
    //   return (
    //     navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
    //     "micromessenger"
    //   );
    // },
  },
};
</script>

<style>
:root {
  --radius: 20px;
  --cardBg: #fff;
  --textColor: #30833d;
  --textSize: 23px;
  --lineHeight: 47px;
  --space: 1px;
  --padding: 50px;
  --paddingHorizontal: 100px;
  --margin: 30px;
}
.container {
  background-color: #daf7f6;
  padding-bottom: 100px;
  position: relative;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.header {
  width: 100%;
  height: 1535px;
}

.activity-background-wrap,
.activity-theme-wrap,
.activity-content-wrap {
  position: relative;
  border-radius: var(--radius);
  background-color: var(--cardBg);
  margin: 0 var(--margin);
  display: flex;
  justify-content: center;
  box-shadow: 0px 18px 40px 0px rgba(62, 143, 82, 0.25);
  z-index: 100;
  max-width: 1003px;
}

.activity-background-wrap {
  margin-top: 120px;
}

.activity-background,
.activity-theme,
.activity-content {
  color: var(--textColor);
  font-size: var(--textSize);
  line-height: var(--lineHeight);
  letter-spacing: var(--space);
  padding: var(--padding) var(--paddingHorizontal);
  padding-top: 110px;
  text-indent: 2em;
}

.img-activity-background-title,
.img-activity-theme-title,
.img-activity-content-title {
  width: 514px;
  height: 117px;
  position: absolute;
  top: -59px;
}

.activity-theme-wrap {
  margin-top: 120px;
}
.activity-content-wrap {
  margin-top: 115px;
}
.activity-content {
  text-indent: 0em;
  padding: 130px 50px 50px 50px;
}
.img-activity-content-item-title {
  width: 334px;
  height: 57px;
  margin-top: 50px;
}

.img-activity-content-item-title:first-child {
  margin-top: 0px;
}

.content-item {
  padding: 15px 50px 0px;
}

.content-mode {
  color: var(--textColor);
  font-weight: bolder;
  padding: 0 35px;
  font-size: 30px;
}
.content-email {
  position: relative;
}
.content-email::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0px;
  right: 0px;
  background-color: #f9cb07;
  height: 7px;
}
.btn-download-wrap {
  display: flex;
  justify-content: center;
  margin-top: 70px;
  margin-bottom: 85px;
  position: relative;
}

.img-right-leaf-above {
  position: absolute;
  right: -50px;
  top: 45px;
  width: 183px;
  height: 210px;
}

.img-right-leaf {
  position: absolute;
  right: -35px;
  width: 237px;
  height: 269px;
}

.offset-right-0 {
  top: 2800px;
}

.offset-right-1 {
  bottom: 1120px;
}

.btn_download {
  width: 289px;
  height: 77px;
}

.btn-submit-wrap {
  display: flex;
  align-items: center;
  flex-direction: column;
  color: #999;
  margin-top: 60px;
  margin-bottom: 50px;
}

.btn-submit {
  width: 289px;
  height: 77px;
  margin-top: 40px;
}

.img-star {
  width: 56px;
  height: 56px;
  position: absolute;
  right: 40px;
  top: 110px;
}

.img-left-leaf {
  position: absolute;
  left: 0px;
  width: 214px;
  height: 236px;
  z-index: 9;
}

.img-left-leaf-big {
  position: absolute;
  left: 0px;
  width: 234px;
  height: 269px;
  z-index: 9;
}

.offset-0 {
  top: 1900px;
}
.offset-1 {
  top: 6300px;
}

.offset-2 {
  bottom: 0px;
}
.activity-form {
  padding: 40px 50px 0px;
}

.pcPopup {
  padding: 0px;
  overflow-y: scroll;
  height: 60vh;
}

.msgBox {
  width: 30%;
  color: #999;
  font-size: 24px;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
}

.msgTitle {
  text-align: center;
  border-bottom: #b2b2b2 2px solid;
  min-height: 86px;
  line-height: 86px;
  padding: 10px 50px 15px;
}

.msgBtn {
  text-align: center;
  line-height: 55px;
  color: #26a2ff;
}

</style>